if (window.location.pathname.includes('social-link')) {
  import('./bootstrapSocialLink' /* webpackChunkName: 'bootstrapSocialLink' */);
} else {
  import('./bootstrap' /* webpackChunkName: 'bootstrap' */);
}
export {};
